import PropTypes from 'prop-types'
import React from 'react'

import {ordinalify} from './util'

import MemberCallout from './MemberCallout'

import './SelectedWard.css'

const SelectedWard = ({ward, alderman, emailSubjectTpl, emailBodyTpl}) => {
  if (!ward || !alderman) {
    return false
  }

  const wardName = ordinalify(ward)

  return (
    <div className="SelectedWard">
      <p>That address is in the {wardName} Ward. The alderperson is {alderman.name}.</p>
      <MemberCallout member={alderman} />
    </div>
  )
}

SelectedWard.propTypes = {
  ward: PropTypes.number,
  alderman: PropTypes.object,
  emailSubjectTpl: PropTypes.func,
  emailBodyTpl: PropTypes.func
}

export default SelectedWard



// WEBPACK FOOTER //
// ./src/SelectedWard.js